export default __webpack_public_path__ + "static/media/ladakh.7e9456f2.jpg";